// extracted by mini-css-extract-plugin
export var container = "VerticalEgg-module--container--encnm";